module.exports = __webpack_public_path__ + "static/media/img44.47e7cdda.jpg";